import { render, staticRenderFns } from "./HoldingSelect.vue?vue&type=template&id=0ed00786"
import script from "./HoldingSelect.vue?vue&type=script&lang=js"
export * from "./HoldingSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ed00786')) {
      api.createRecord('0ed00786', component.options)
    } else {
      api.reload('0ed00786', component.options)
    }
    module.hot.accept("./HoldingSelect.vue?vue&type=template&id=0ed00786", function () {
      api.rerender('0ed00786', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/holding-select/HoldingSelect.vue"
export default component.exports